import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-in-home-care-assigned',
  standalone: false,
  templateUrl: './in-home-care-assigned.component.html',
  styleUrl: './in-home-care-assigned.component.scss'
})
export class InHomeCareAssignedComponent {

}
